import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { FormsModule } from '@angular/forms';
import { AccountCommonModule } from 'account-hybrid/common/common.module';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { ShortUrlListComponent } from './short-url-list/short-url-list.component';
import { ShortLinkCodeUniqueValidatorDirective } from './short-url-wizard/short-link-code-unique-validator';
import { ShortLinkNameUniqueValidatorDirective } from './short-url-wizard/short-link-name-unique-validator';
import { ShortUrlWizardComponent } from './short-url-wizard/short-url-wizard.component';
import { ShortUrlService } from './short-urls.service';

@NgModule({
    declarations: [
        ShortLinkCodeUniqueValidatorDirective,
        ShortLinkNameUniqueValidatorDirective,
        ShortUrlListComponent,
        ShortUrlWizardComponent
    ],
    providers: [
        ShortUrlService
    ],
    imports: [
        FormsModule,
        CommonModule,
        AccountCommonModule,
        AccountSharedModule
    ],
    exports: [
        ShortLinkCodeUniqueValidatorDirective,
        ShortLinkNameUniqueValidatorDirective,
        ShortUrlListComponent,
        ShortUrlWizardComponent
    ]
})
export class ShortUrlsModule {

}
